<div class="trending-docs">
    <ng-container *ngIf="trendingDocuments && trendingDocuments.length > 0; else loading">
        <div class="content-card" *ngFor="let link of trendingDocuments | slice: fs:ls; let i=index">
            <p title="{{link.title}}" class="mb-0 link-title">{{link.title}}</p>
            <p class="link-text">{{link.webshorturl}}</p>
            <div class="trend-img text-center">
                <a
                    href="{{link.webshorturl}}"
                    target="_blank"
                    appInsightsTrack
                    [eventData]=link
                    loc={{consts.TITLE}}
                >
                    <ng-container *ngIf="link.hasfile; else noFile">
                        <div class="hasfile">
                            <ng-container *ngIf="link.displayurl; else noUrl">
                                <img
                                    class="img-fluid preview-img"
                                    src="{{link.displayurl}}"
                                >
                            </ng-container>
                            <ng-template #noUrl>
                                <mat-icon
                                    class="icon"
                                    svgIcon="hub_{{link.preimgurl}}"
                                >
                                </mat-icon>
                            </ng-template>
                        </div>
                    </ng-container>
                    <ng-template #noFile>
                        <div class="not-hasfile">
                            <mat-icon
                                class="icon"
                                svgIcon="hub_generic"
                            >
                            </mat-icon>
                            <div class="extension">{{link.preimgurl}}</div>
                        </div>
                    </ng-template>
                </a>
            </div>
            <mat-icon svgIcon="hub_{{link.icon}}"></mat-icon>
            <p class="text-type">{{link.icontype}}</p>
            <div class="text-center link-menu" [matMenuTriggerFor]="menu">
                <mat-icon 
                    class="action-icon" 
                    svgIcon="hub_more_horiz"
                >
                </mat-icon>
                <mat-menu #menu="matMenu">
                    <button
                        mat-menu-item
                        class="mat-menu-option"
                        (click)="openLink(link.webshorturl);"
                        appInsightsTrack
                        [eventData]=link
                        loc="{{consts.TITLE}}"
                        action="{{consts.LABEL_OPEN}}"
                    >
                        <mat-icon 
                            class="menu-icon" 
                            svgIcon="hub_folder_icon"
                        >
                        </mat-icon>
                        <span>{{consts.LABEL_OPEN}}</span>
                    </button>
                    <button
                        mat-menu-item
                        class="mat-menu-option"
                        ngxClipboard
                        [cbContent]="link.webshorturl"
                        (click)="openSnackBar()"
                        appInsightsTrack
                        [eventData]=link
                        loc="{{consts.TITLE}}"
                        action="{{consts.LABEL_COPY}}"
                    >
                        <mat-icon 
                            class="menu-icon" 
                            svgIcon="hub_link"
                        >
                        </mat-icon>
                        <span>{{consts.LABEL_COPY}}</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </ng-container>
    <ng-template #loading>
        <div class="loading-spinner">
            <mat-spinner matSuffix [diameter]="30"></mat-spinner>
        </div>
    </ng-template>
</div>
